<template>
  <div class="w-full overflow-x-scroll">
    <table>
      <thead>
        <tr class="bg-grey-7 text-grey-3 border-t border-b border-yellow-7">
          <th>Username</th>
          <th>Name</th>
          <th v-if="$auth.check('admin')">Email</th>
          <th>Role</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <user-admin-row v-for="user in users" :key="user.username" :user="user" />
      </tbody>
    </table>
  </div>
</template>

<script>
import UserAdminRow from "./UserAdminRow"

export default {
  name: "UserAdminTable",
  components: {
    UserAdminRow
  },
  props: {
    users: {
      required: true
    }
  }
}
</script>

